module.exports = __webpack_public_path__ + "assets/64ee5038ea73dbc4fd73902124621de8.mp4";